module.exports = __webpack_public_path__ + "media/images/user/lp/solution/request-9e521e9d71657b29910274bdb39e2078.png";